<!-- Employees -->
<oth-hero [contents]="partnersTitle"></oth-hero>
<div class="business-partners-wrapper">
  <app-business-partner-swiper [partners]="PARTNERS">
  </app-business-partner-swiper>
  <app-cookies></app-cookies>
</div>

<div class="cards-wrapper">
  <oth-button [buttonClasses]="['theme-color-border-color', 'theme-color-font-color', 'transparent-button']" [routerLink]="URLS.contactUs"
              [text]="'Join our partner program'">
  </oth-button>
</div>
